import { Heading } from '@chakra-ui/react';

function Header() {
  return (
    <header className="container mx-auto">
      <Heading as="h1">Records</Heading>
    </header>
  );
}

export default Header;
